<template>
    <div>
        <search-fields v-model="filters" @resetFilters="resetFilters"/>
        <v-divider class="my-2"/>
        <b-data-table
            :headers="headers"
            :items="items"
            :page="paginator.currentPage"
            :options.sync="dataTableOptions"
            :items-per-page="paginator.perPage"
            :loading="loading"
            :disable-sort="loading"
            :server-items-length="paginator.total"
            show-expand
            @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
            class="table-cursor"
        >
            <template v-slot:item.name="{ item }">
                {{ item.name }}
                <v-icon v-if="item.product.travalco_eid" small left color="red">mdi-alpha-t-circle-outline
                </v-icon>
            </template>
            <template v-slot:item.type="{ item }">
                {{ item.type.name }}
            </template>
            <template v-slot:item.country="{ item }">
                {{ item.country.code }} - {{ item.country.label }}
            </template>
            <template v-slot:item.code="{ item }">
                {{ item.full_code }}
            </template>
            <template v-slot:item.default_duration="{ item }">
                {{ item.minimum_nights }} nacht(en)
            </template>
            <template v-slot:item.lowestSalePrice="{ item }">
                        <span v-if="item.lowestSalePrice != null">
                            {{ item.lowestSalePrice.total_sale_price |formattedPrice }}
                        </span>
                <span v-else>
                            &euro; --
                        </span>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                    <v-row>
                        <v-col md="5" cols="12">
                            <PackageGeneralInfo :item="item"/>
                        </v-col>
                        <v-col md="7" cols="12">

                            <b-alert class="my-5" color="warning"
                                     v-if="!filters.book_date || !filters.departure_date">
                                <strong>Geen prijs informatie beschikbaar.</strong>
                                Vertrek en/of boekingdatum niet correct ingevuld.
                            </b-alert>

                            <PackageProductsInfo v-if="filters.book_date && filters.departure_date"
                                                 :packageObj="item" :adults="filters.adults"
                                                 :book-date="filters.book_date"
                                                 :departure-date="filters.departure_date"/>
                        </v-col>
                    </v-row>
                </td>
            </template>
        </b-data-table>
    </div>
</template>

<script>
import SearchFields from "@/components/Package/SearchPrice/SearchFields";
import BDataTable from "@/components/General/Table/BDataTable";
import Package from "@/models/Package/Package";
import PackageType from "@/models/Package/PackageType/PackageType";
import map from "lodash/map";
import moment from "moment";
import PackageGeneralInfo from "@/components/Package/SearchPrice/GerneralInfo";
import PackageProductsInfo from "@/components/Package/SearchPrice/PackageProductsInfo";
import BAlert from "@/components/General/Alert/BAlert";
import BasicSearchMixin from "@/mixins/BasicSearchMixin";

export default {
    mixins: [
        BasicSearchMixin
    ],
    name: "PackagePriceModal",
    components: {BAlert, PackageProductsInfo, PackageGeneralInfo, SearchFields, BDataTable},
    data() {
        return {
            defaultFilters: {
                package_type_ids: [],
                adults: 2,
                book_date: moment().format('YYYY-MM-DD'),
            },
            headers: [
                {text: 'Naam', value: 'title', sortable: false},
                {text: 'Type', value: 'type', sortable: false},
                {text: 'Land', value: 'country', sortable: false},
                {text: 'Code', value: 'code', sortable: false},
                {text: 'Duur', value: 'default_duration', sortable: false},
            ],
            items: [],
            appends: [],
            defaultSortBy: {
                title: 'asc',
            },
        }
    },
    computed: {
        packageTypeIds() {
            return map(PackageType.query().all(), 'id');
        },
    },
    methods: {
        search() {
            this.loading = true;
                 Package.api()
                .paginator(this.paginator)
                .where('is_active', true)
                .where('is_published', true)
                .limit(30)
                .with([
                    'tags',
                    'regions',
                    'country',
                    'type',
                    'websitePackage',
                    'lowestSalePrice',
                    'activeLines',
                    'activeLines.product',
                    'activeLines.product.activeActiveVersion.country',
                    'activeLines.product.activeActiveVersion.flight',
                    'activeLines.product.activeActiveVersion.flight.departureAirport',
                    'activeLines.product.activeActiveVersion.flight.arrivalAirport',
                ])
                .ordered(this.sortBy)
                .filtered(this.filters)
                .get()
                .then((response) => {
                    this.items = response;
                    this.loading = false;
                });
        },
    },
    created() {
        PackageType.api().get(true).then(() => {
            this.defaultFilters.package_type_ids = this.packageTypeIds;
            this.resetFilters();
        });
    }
}
</script>
